import { AppConstant } from 'src/app/config/app.constant';
import { map } from 'rxjs/operators';
import { ApiService } from 'src/app/services/api.service';
import { Injectable } from "@angular/core";
import { APIs } from '../config/api.constant';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OverviewService {
  constructor(private apiService: ApiService) { }

  getParkiteOverviewDetail(data) {
    return this.apiService.get(APIs.getOverviewDetails, data).pipe(map(response => {
      return response.data;
    }))
  }

  getOverViewDataForSurveyOnly(parkId: string) {
    return this.apiService.get(APIs.getSurveyDashBoardData + '?ParkId=' + parkId).pipe(map(response => {
      return response.data;
    }))
  }

  getOverViewData() {
    let locationId = localStorage.getItem("locationId") ?? 1;
    return this.apiService.get(APIs.getOverviewCLA + '?locationId=' + locationId).pipe(map(response => {
      return response;
    }))
  }

  getDayPass() {
    const paramObj = {
      client_id: environment.officeRndClientId,
      client_secret: environment.officeRndClientSecret,
      grant_type: "client_credentials",
      scope: "officernd.api.read officernd.api.write"
    };
    return this.apiService.get(APIs.getAuthToken, paramObj).pipe(map(r => {
      return this.apiService.get(APIs.getDayPass, { Authorization: r.access_token }).pipe(map(response => {
        return response;
      }))
    }));

  }

  getParkingData() {
    let locationId = localStorage.getItem("locationId") ?? 1;
    return this.apiService.get(APIs.parking, { Authorization: localStorage.getItem(AppConstant.localStorage.token), locationId: locationId }).pipe(map(response => {
      return response;
    }))
  }
}
